import FakeCards from './FakeCards';
import './FakeCards.scss';

export default FakeCards;
